import React from 'react';

const MoreInformation = () => (
  <div className="more-information">
    <h4>Więcej informacji</h4>
    <p>
      Aktualne informacje na temat sytuacji epidemicznej oraz inne porady i
      wskazówki, znajdziesz na www.gov.pl/koronawirus
    </p>
    <small>
      Wyniki Testu służą wyłącznie celom informacyjnym oraz edukacyjnym. Nie
      traktuj ich jako konsultacji lub diagnozy lekarskiej.
    </small>
  </div>
);

export default MoreInformation;
